import {differenceInDays, isAfter, isBefore, isSameDay} from 'date-fns';
import type {DateRange} from 'react-day-picker';
import {resetTime, toDate, type DateInput} from './dateUtils';

type IsDayBlockedProps = {
  maxDays?: number;
  minDays?: number;
  minDate?: DateInput;
  maxDate?: DateInput;
  datesRange?: DateRange;
};

export const isDayBlocked =
  ({minDate, maxDate, maxDays, minDays, datesRange}: IsDayBlockedProps) =>
  (date: Date) => {
    const startDate = datesRange?.from ? resetTime(datesRange.from) : null;
    const endDate = datesRange?.to ? resetTime(datesRange.to) : null;
    const min = toDate(minDate);
    const max = toDate(maxDate);

    if (maxDays) {
      if (startDate && Math.abs(differenceInDays(date, startDate)) + 1 > maxDays) {
        return true;
      }
      if (endDate && Math.abs(differenceInDays(date, endDate)) + 1 > maxDays) {
        return true;
      }
    }

    if (minDays) {
      if (
        startDate &&
        !isSameDay(date, startDate) &&
        Math.abs(differenceInDays(date, startDate)) < minDays
      ) {
        return true;
      }
      if (
        endDate &&
        !isSameDay(date, endDate) &&
        Math.abs(differenceInDays(date, endDate)) < minDays
      ) {
        return true;
      }
    }

    if (min && isBefore(date, resetTime(min))) return true;
    if (max && isAfter(date, resetTime(max))) return true;

    return false;
  };
